import { render } from "./UtvekslingLogo.vue?vue&type=template&id=6bc7fe79&scoped=true"
import script from "./UtvekslingLogo.vue?vue&type=script&lang=js"
export * from "./UtvekslingLogo.vue?vue&type=script&lang=js"

import "./UtvekslingLogo.vue?vue&type=style&index=0&id=6bc7fe79&scoped=true&lang=css"
import "./UtvekslingLogo.vue?vue&type=style&index=1&id=6bc7fe79&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bc7fe79"]])

export default __exports__